import { EventEmitter } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
function AutocompleterSingleSelectListComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵelement(2, "div", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r0.selectedItem.name);
} }
function AutocompleterSingleSelectListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, AutocompleterSingleSelectListComponent_div_2_div_1_Template, 3, 1, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.selectedItem.type === ctx_r0.autocompleterName);
} }
/**
 * Autocompleter Single Select List Component
 *
 * Allows the selection of a single result from an autocompleter, then displays the selected result
 * below the autocompleter input box.
 *
 * Input Properties:
 *  autocompleterName: type of things to search for in base autocomplete.
 *  autocompleterPlaceholder: string to show in the autocompleter input box when it is empty.
 *  selectItem: object that is the currently selected autocomplete result or security list item.
 *
 * Output Properties:
 *  selectItemHandler: Emits the selected AutocompleteResult when a new selection is made.
 */
export class AutocompleterSingleSelectListComponent {
    constructor() {
        this.selectedItem = null;
        this.selectItemHandler = new EventEmitter();
    }
    selectResult(result) {
        // If an item is already selected, we must remove it first.
        if (this.selectedItem) {
            const oldItem = cloneDeep(this.selectedItem);
            this.selectItemHandler.emit(oldItem);
        }
        this.selectedItem = result;
        this.selectItemHandler.emit(this.selectedItem);
    }
}
AutocompleterSingleSelectListComponent.ɵfac = function AutocompleterSingleSelectListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AutocompleterSingleSelectListComponent)(); };
AutocompleterSingleSelectListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AutocompleterSingleSelectListComponent, selectors: [["ycn-autocompleter-single-select-list"]], inputs: { autocompleterName: "autocompleterName", autocompleterPlaceholder: "autocompleterPlaceholder", selectedItem: "selectedItem" }, outputs: { selectItemHandler: "selectItemHandler" }, standalone: false, decls: 3, vars: 4, consts: [[1, "linked-list-body-content"], [3, "submitHandler", "appendToBody", "placeholder", "searchType"], ["class", "options-list", 4, "ngIf"], [1, "options-list"], ["class", "options-list-item", 4, "ngIf"], [1, "options-list-item"], [1, "options-list-item-header"], [1, "options-list-item-title", 3, "textContent"]], template: function AutocompleterSingleSelectListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ycn-icon-search-autocomplete", 1);
        i0.ɵɵlistener("submitHandler", function AutocompleterSingleSelectListComponent_Template_ycn_icon_search_autocomplete_submitHandler_1_listener($event) { return ctx.selectResult($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, AutocompleterSingleSelectListComponent_div_2_Template, 2, 1, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("appendToBody", false)("placeholder", ctx.autocompleterPlaceholder)("searchType", ctx.autocompleterName);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.selectedItem);
    } }, dependencies: [i1.NgIf, i2.IconSearchAutocompleteComponent], encapsulation: 2 });
